import type { BoxResult } from '../types';

export type PackageWithTareWeight = {
  tareWeight?: { value?: number } | null;
};

export const calculatePackageWeight = (
  itemPositions: BoxResult['itemPositions'],
  selectedPackage: PackageWithTareWeight | null | undefined,
  sellerWeightUnit: string,
): { value: number; unit: string } => {
  const itemsWeight = itemPositions?.reduce((sum, position) => sum + (position.item?.weight ?? 0), 0) ?? 0;
  const tareWeight = selectedPackage?.tareWeight?.value ?? 0;

  return { value: Math.round((itemsWeight + tareWeight) * 100) / 100, unit: sellerWeightUnit };
};
